import { render, staticRenderFns } from "./WhatIsGarcinia.vue?vue&type=template&id=7d7017fc&"
import script from "./WhatIsGarcinia.vue?vue&type=script&lang=js&"
export * from "./WhatIsGarcinia.vue?vue&type=script&lang=js&"
import style0 from "./WhatIsGarcinia.vue?vue&type=style&index=0&id=7d7017fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports